// src/directives/clickOutside.js

/**
 * A Vue 3 directive that triggers a callback when a click event occurs outside the element it's attached to.
 */
export const vClickOutside = {
  beforeMount(el, binding) {
    // Define the event handler
    el.clickOutsideEvent = function (event) {
      // Check if the clicked element is neither the element itself nor a descendant of the element.
      if (!(el === event.target || el.contains(event.target))) {
        // If the click is outside, call the method passed to the directive.
        // The method is received from the 'binding.value' property.
        binding.value(event)
      }
    }
    // Add the event listener to the whole document
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    // Clean up the event listener when the component is unmounted to prevent memory leaks.
    document.removeEventListener('click', el.clickOutsideEvent)
  },
}
